import React, { useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import { keyEmptyCheck } from 'aurora-utils/utils';

import styles from './styles';

function NonEditablePermissions({ classes, langKeys, permissions }) {
  const [activeTab, setActiveTab] = useState(0);

  const handleChange = (_, newValue) => {
    setActiveTab(newValue);
  };

  const activeTabData = useMemo(() => {
    return permissions?.groupPermissions?.[activeTab];
  }, [activeTab, permissions]);

  const renderPermission = permission => {
    return (
      <div className={classes.serviceContainer} key={permission?.serviceId}>
        <Typography className={classes.serviceName}>{permission[langKeys.serviceName]}</Typography>
        {permission?.stepPermissionList?.length > 0 && (
          <div className={classes.permissionContainer}>
            {permission?.stepPermissionList?.map(stepPermission => (
              <Typography key={stepPermission?.stepId} className={classes.permissionName}>
                {stepPermission[langKeys.stepName]}
              </Typography>
            ))}
          </div>
        )}
      </div>
    );
  };

  return (
    <>
      <div className={classes.header}>
        <Typography className={classes.headerTitle}>{keyEmptyCheck('module')}</Typography>
        <Typography className={classes.headerTitle}>{keyEmptyCheck('SERVICE')}</Typography>
        <Typography className={classes.headerTitle}>{keyEmptyCheck('permissions')}</Typography>
      </div>
      <div className={classes.body}>
        <Tabs
          orientation='vertical'
          variant='scrollable'
          value={activeTab}
          onChange={handleChange}
          className={classes.tabs}
        >
          {permissions?.groupPermissions?.map((group, i) => (
            <Tab
              key={group?.groupId}
              className={classNames(classes.tab, {
                [classes.tabActive]: activeTab === i,
              })}
              id={`tab-${i}`}
              aria-controls={`tabpanel-${i}`}
              disableRipple
              label={
                <div className={classes.tabTitleContainer}>
                  <Typography className={classes.tabTitle}>{group[langKeys.groupName]}</Typography>
                  {activeTab === i && (
                    <span className={classes.tabArrowIcon}>
                      <svg width='16' height='17' viewBox='0 0 16 17' fill='none' xmlns='http://www.w3.org/2000/svg'>
                        <path
                          d='M8.78145 8.49999L5.48145 5.19999L6.42411 4.25732L10.6668 8.49999L6.42411 12.7427L5.48145 11.8L8.78145 8.49999Z'
                          fill='white'
                        />
                      </svg>
                    </span>
                  )}
                </div>
              }
            />
          ))}
        </Tabs>
        {activeTabData?.permissionList?.length > 0 && (
          <div className={classes.serviceAndPermissionsContainer}>
            {activeTabData?.permissionList?.map(permission => renderPermission(permission))}
          </div>
        )}
      </div>
    </>
  );
}

NonEditablePermissions.propTypes = {
  classes: PropTypes.object.isRequired,
  langKeys: PropTypes.object.isRequired,
  permissions: PropTypes.object.isRequired,
};

export default withStyles(styles)(NonEditablePermissions);
